<ng-container>
  <!-- <div *ngIf="!selectedCountry" class="location-page-header">
  <div>Select your location</div>
  <div>
    <i class="fa fa-map-marker-alt"></i>
  </div>
</div> -->
@if (selectedCountry) {
  <div class="location-page-header">
    <div>
      <img
        class="icon-flag"
        [src]="'assets/images/flags/' + (selectedCountry === 'uk' ? 'uk' : 'usa') + '-flag.svg'"
        alt="Flag"
        >
    </div>
    <div>Select your game</div>
  </div>
}
<!-- <div class="countries d-flex justify-content-around" *ngIf="!selectedCountry">
<div class="m-3" *ngIf="checkIfCountry('us')">
  <h2 class="flag-label">USA</h2>
  <div
    class="flag-wrapper"
    (click)="chooseTheCountry('us')"
    (mouseover)="hoverUS=true"
    (mouseleave)="hoverUS=false"
    >
    <img
      class="p-0 border-0 btn"
      [ngClass]="hoverUS ? 'shadow-lg' : 'shadow'"
      [src]="'assets/images/flags/usa-flag.svg'"
      [alt]="'USA Flag'"
      >
  </div>
</div>
<div class="m-3" *ngIf="checkIfCountry('uk')">
  <h2 class="flag-label">UK</h2>
  <div
    class="flag-wrapper"
    (click)="chooseTheCountry('uk')"
    (mouseover)="hoverUK = true"
    (mouseleave)="hoverUK = false"
    >
    <img
      class="p-0 border-0 btn"
      [ngClass]="hoverUK ? 'shadow-lg' : 'shadow'"
      [src]="'assets/images/flags/uk-flag.svg'"
      [alt]="'UK Flag'"
      >
  </div>
</div>
</div> -->
<div class="games d-flex flex-column justify-content-around">
  @for (game of games; track game) {
    <div
      class="m-3 p-0 border-0 btn"
      [ngClass]="game.isHover ? 'shadow-lg' : 'shadow'"
      >
      <div
        class="game-wrapper"
        (click)="chooseTheGame(game.id)"
        (mouseover)="game.isHover=true"
        (mouseleave)="game.isHover=false"
        >
        @if (!getCountryImage(game.title)) {
          <div class="course-text-container">
            <div class="outer">
              <div class="course-title"><p>{{game.title}}</p></div>
            </div>
          </div>
        }
        @if (getCountryImage(game.title)) {
          <div class="course-image-container">
            <img [src]="getCountryImage(game.title)">
          </div>
        }
        @if (game.progress) {
          <div class="progress">
            <div class="progress-bar bg-success" role="progressbar" [style.width.%]="game.progress < 10 ? 10 : game.progress"
              attr.aria-valuenow=10 aria-valuemin="0"
              aria-valuemax="100">
              {{ game.progress | number:'1.0-0' }}&#37;
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
</ng-container>
